import { stateKey } from '../../../app/state-key.js';
import { productEnrichmentOptionsSchema } from '../../../features/commerce/product-enrichment/product-enrichment.js';
import { fetchBadges, registerProductEnrichmentOptions, } from '../../../features/commerce/product-enrichment/product-enrichment-actions.js';
import { productEnrichmentReducer as productEnrichment } from '../../../features/commerce/product-enrichment/product-enrichment-slice.js';
import { loadReducerError } from '../../../utils/errors.js';
import { validateInitialState } from '../../../utils/validate-payload.js';
import { buildController, } from '../../controller/headless-controller.js';
const defaultProductEnrichmentOptions = {
    placementIds: [],
    productId: undefined,
};
function validateProductEnrichmentProps(engine, props) {
    validateInitialState(engine, productEnrichmentOptionsSchema, props?.options, 'buildProductEnrichment');
}
/**
 * Creates a `ProductEnrichment` controller instance.
 *
 * @param engine - The headless engine.
 * @param props - The configuration `ProductEnrichment` properties.
 * @returns A `ProductEnrichment` controller instance.
 *
 * @group Buildable controllers
 * @category ProductEnrichment
 *
 * */
export function buildProductEnrichment(engine, props) {
    if (!loadProductEnrichmentReducer(engine)) {
        throw loadReducerError;
    }
    const controller = buildController(engine);
    const { dispatch } = engine;
    const getState = () => engine[stateKey];
    const registrationOptions = {
        ...defaultProductEnrichmentOptions,
        ...props?.options,
    };
    validateProductEnrichmentProps(engine, {
        options: props?.options,
    });
    // Register the options in state so they can be recovered during SSR hydration
    dispatch(registerProductEnrichmentOptions({
        productId: registrationOptions.productId,
        placementIds: registrationOptions.placementIds,
    }));
    return {
        ...controller,
        get state() {
            return getState().productEnrichment;
        },
        getBadges() {
            const { placementIds, productId } = getState().productEnrichment;
            if (!placementIds || placementIds.length === 0) {
                throw new Error('placementIds must be provided and non-empty to fetch badges');
            }
            dispatch(fetchBadges({
                placementIds,
                productId,
            }));
        },
    };
}
function loadProductEnrichmentReducer(engine) {
    engine.addReducers({ productEnrichment });
    return true;
}
